// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"76cb0058","246":"e988f55b","455":"c92d003a","488":"d330f8fb","977":"b64d262f"}[chunkId] + ".chunk.js";
};